import { MultiStepWizard as BaseMultiStepWizard } from './MultiStepWizard/MultiStepWizard'
import { useRootStore } from 'stores/RootStore'
import { useGenerateContent } from 'components/Wizards/Wizard/useGenerateContent'
import { observer } from 'mobx-react-lite'
import { MultiStepWizardProps } from 'components/Wizards/Types'
import { MultiStepWizardProps as BaseMultiStepWizardProps } from 'components/Wizards/MultiStepWizard/Types'
import { object } from 'yup'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project } from 'components/Wizards/schemas/shared/project'
import { StepSchema } from 'components/Wizards/schemas/Types'
import { Step } from 'components/Wizards/MultiStepWizard/Step'
import { SelectImages } from 'components/Wizards/SelectImages/SelectImages'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'
import { multiStep } from 'components/Wizards/MultiStepWizard/multiStep'
import { ImagesProvider, useImages, useUnsplashImages } from 'components/Wizards/SelectImages/ImagesProvider'
import { WizardProvider } from './Wizard/WizardContext'
import { useEffect } from 'react'

export const FirstStep = multiStep(({ onSubmit, ...props }: StepProps) => {
  const { generateImageKeywords, topic } = useImages()
  const { clearPhotos, setPage } = useUnsplashImages()

  const handleSubmit = (values: any) => {
    const newTopic = values.topic || values.goal || values.filename

    if (topic !== newTopic) {
      clearPhotos()
      setPage(1)
      generateImageKeywords({ topic: newTopic })
    }
    return onSubmit(values)
  }

  return <Step {...props} onSubmit={handleSubmit} />
})

const MultiStepWizard = (props: BaseMultiStepWizardProps) => {
  const { abort } = useImages()

  useEffect(() => {
    return abort
  }, [abort])

  return (
    <BaseMultiStepWizard.Root {...props}>
      <FirstStep />
      <SelectImages />
    </BaseMultiStepWizard.Root>
  )
}

const MultiStepWizardContainer = observer(
  ({ schema, articleId, layerId, onSuccess, ...props }: MultiStepWizardProps) => {
    const { handbooks } = useRootStore()
    const { channel } = schema.meta
    const isCreatingNewFile = !articleId
    const multiStepSchema = { ...schema }
    if (isCreatingNewFile) {
      multiStepSchema.steps = [
        multiStepSchema.steps[0].concat(object({ filename, project })) as StepSchema,
        ...multiStepSchema.steps.slice(1),
      ]
    }

    const { generateContent } = useGenerateContent({
      generationType: channel,
      articleId,
      onSuccess,
      layerId,
    })

    return (
      <WizardProvider schema={multiStepSchema}>
        <ImagesProvider initialMaxPhotos={6}>
          <MultiStepWizard
            onSubmit={async (values) => {
              await generateContent(values)
              handbooks.refresh(values.project?.handbook?.key)
            }}
            schema={multiStepSchema}
            {...props}
          />
        </ImagesProvider>
      </WizardProvider>
    )
  },
)

export { MultiStepWizardContainer as MultiStepWizard }
